import { render, staticRenderFns } from "./SelectComponente.vue?vue&type=template&id=1dcd2852&"
import script from "./SelectComponente.vue?vue&type=script&lang=js&"
export * from "./SelectComponente.vue?vue&type=script&lang=js&"
import style0 from "./SelectComponente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports